import {
  BarChartSquare02,
  File05,
  Calendar,
  MessageChatCircle,
  CheckDone01,
  Users01,
  Inbox02,
  Stars02,
  Stars03,
  ShoppingBag02,
} from '@untitledui/icons';
import CompanyVerificationPage from './company/CompanyVerificationPage';
import PublicationSection from './publications/PublicationSection';
import UnitsSection       from './units/UnitsSection';
import BookingSection     from './booking/BookingSection';
import CustomerReservationsSection from './booking/CustomerReservationsSection';
import SupportTicketsSection from './support/SupportTicketsSection';
import SupportCreateTicketSection from './support/SupportCreateTicketSection';
import SolicitudesSection from './solicitudes/SolicitudesSection';
import FeedSection        from './feed/FeedSection';
import MarketplaceSection from './marketplace/MarketplaceSection';
import CalendarSection    from './calendar/CalendarSection';
import PromoteSection     from './promote/PromoteSection';
import SubscriptionsSection from './subscriptions/SubscriptionsSection';
import StatisticsReportsSection from './statistics/StatisticsReportsSection';
import StatisticsClientsSection from './statistics/StatisticsClientsSection';
import StatisticsProvidersSection from './statistics/StatisticsProvidersSection';
import NotificationsSection from './notifications/NotificationsSection';

export const MENU_SECTIONS = [
  {
    label: 'Resumen',
    items: [
      { label: 'Feed', key: 'feed', icon: MessageChatCircle, roles: ['user', 'admin'] },
      { label: 'Marketplace', key: 'marketplace', icon: ShoppingBag02, roles: ['user', 'admin'] },
      { label: 'Notificaciones', key: 'notificaciones', icon: Inbox02, roles: ['user', 'admin'] },
    ],
  },
  {
    label: 'Solicitudes',
    items: [
      {
        label: 'Reservas',
        key: 'reservas',
        icon: Calendar,
        roles: ['user', 'admin'],
        audiences: ['provider'],
      },
      {
        label: 'Mis reservas',
        key: 'reservas-cliente',
        icon: Calendar,
        roles: ['user', 'admin'],
        audiences: ['client'],
      },
      {
        label: 'Centro de solicitudes',
        key: 'solicitudes',
        icon: Inbox02,
        roles: ['user', 'admin'],
      },
    ],
  },
  {
    label: 'Operaciones',
    items: [
      {
        label: 'Flotilla',
        key: 'unidades',
        icon: BarChartSquare02,
        roles: ['user', 'admin'],
      },
      { label: 'Publicaciones', key: 'publicaciones', icon: File05, roles: ['user', 'admin'] },
      {
        label: 'Promocionar',
        key: 'promocionar',
        icon: Stars02,
        roles: ['user', 'admin'],
        hiddenInSidebar: true,
      },
      {
        label: 'Verificacion',
        key: 'empresa-verificacion',
        icon: CheckDone01,
        roles: ['user', 'admin'],
        hiddenInSidebar: true,
      },
      {
        label: 'Calendario',
        key: 'calendario',
        icon: Calendar,
        roles: ['user', 'admin'],
        hiddenInSidebar: true,
      },
    ],
  },
  {
    label: 'Estadísticas',
    items: [
      {
        label: 'Reportes',
        key: 'estadisticas-reportes',
        icon: BarChartSquare02,
        roles: ['user', 'admin'],
      },
      {
        label: 'Clientes',
        key: 'estadisticas-clientes',
        icon: Users01,
        roles: ['user', 'admin'],
        audiences: ['client'],
      },
      {
        label: 'Proveedores',
        key: 'estadisticas-proveedores',
        icon: ShoppingBag02,
        roles: ['user', 'admin'],
        audiences: ['provider'],
      },
    ],
  },
  {
    label: 'Soporte',
    items: [
      {
        label: 'Mis tickets',
        key: 'support-tickets',
        icon: CheckDone01,
        roles: ['user', 'admin'],
        hiddenInSidebar: true,
      },
      {
        label: 'Crear ticket',
        key: 'support-new',
        icon: CheckDone01,
        roles: ['user', 'admin'],
        hiddenInSidebar: true,
      },
    ],
  },
  {
    label: 'Suscripciones',
    items: [
      {
        label: 'Mejora a Flotte Gold',
        key: 'suscripciones',
        icon: Stars03,
        roles: ['user', 'admin'],
      },
    ],
  },
];

export const MENU_ITEMS = MENU_SECTIONS.flatMap(section =>
  section.items.map(item => ({
    ...item,
    section: section.label,
  }))
);

export const SECTION_COMPONENTS = {
  feed:          FeedSection,
  marketplace:   MarketplaceSection,
  calendario:    CalendarSection,
  'empresa-verificacion': CompanyVerificationPage,
  publicaciones: PublicationSection,
  productos:     PublicationSection,
  unidades:      UnitsSection,
  units:         UnitsSection,
  solicitudes:   SolicitudesSection,
  reservas:      BookingSection,
  'reservas-cliente': CustomerReservationsSection,
  support:       SupportTicketsSection,
  'support-tickets': SupportTicketsSection,
  'support-new': SupportCreateTicketSection,
  suscripciones: SubscriptionsSection,
  promocionar:   PromoteSection,
  'estadisticas-reportes': StatisticsReportsSection,
  'estadisticas-clientes': StatisticsClientsSection,
  'estadisticas-proveedores': StatisticsProvidersSection,
  admin:         () => <div className="card"><h3>Administracion</h3></div>,
  notificaciones: NotificationsSection,
};
